/* Learn hub: instant search over server-rendered article links.
   The article list is plain HTML in the page (crawlable). This script only
   adds search on top of it. Full article text is fetched lazily on first use. */
var LearnSearch = (function () {
  var STOP = {};
  ('a an and are as at be can do does for how i if in is it me my of on or should the to ' +
    'was what when where which why will with you your this that there have has get ' +
    'not no out up from into its im isnt wont doesnt dont cant keep keeps am so but')
    .split(' ').forEach(function (w) { STOP[w] = 1; });

  /* Words customers use -> words the articles use. Edit freely. */
  var SYNONYMS = {
    gun: ['machine'], guns: ['machine'],
    glue: ['adhesive', 'latex'], latex: ['adhesive'],
    fabric: ['cloth'], canvas: ['cloth'], monks: ['cloth'],
    ak1: ['ak-i'], ak2: ['ak-ii'], ak3: ['ak-iii'],
    wool: ['yarn'], thread: ['yarn'],
    broken: ['troubleshooting'], fix: ['troubleshooting'], repair: ['troubleshooting'],
    noise: ['sound'], loud: ['sound'], noisy: ['sound'],
    cost: ['price'], pricing: ['price'],
    class: ['workshop'], classes: ['workshop'], lesson: ['workshop'],
    delivery: ['shipping'], refund: ['exchanges'], refunds: ['exchanges'],
    pulling: ['stay'], falling: ['stay'], loose: ['stay'],
    trim: ['carving'], shave: ['carving'], edge: ['binding', 'edges']
  };

  var WEIGHT = { title: 10, tags: 6, excerpt: 3, body: 1 };

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[‘’']/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function stem(w) {
    if (w.length > 5 && /ing$/.test(w)) return w.slice(0, -3);
    if (w.length > 4 && /ed$/.test(w)) return w.slice(0, -2);
    if (w.length > 4 && /ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) return w.slice(0, -1);
    return w;
  }

  function tokens(s) {
    var n = norm(s);
    if (!n) return [];
    return n.split(' ').map(stem);
  }

  /* Bounded edit distance: returns true when a and b are within max edits. */
  function near(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return false;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = [i];
      var rowMin = cur[0];
      for (j = 1; j <= lb; j++) {
        var c = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
        if (i > 1 && j > 1 && a.charCodeAt(i - 1) === b.charCodeAt(j - 2) && a.charCodeAt(i - 2) === b.charCodeAt(j - 1)) {
          cur[j] = Math.min(cur[j], prevPrev[j - 2] + 1);
        }
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > max) return false;
      var prevPrev = prev;
      prev = cur;
    }
    return prev[lb] <= max;
  }

  function fieldSet(text) {
    var list = tokens(text), set = {};
    for (var i = 0; i < list.length; i++) set[list[i]] = (set[list[i]] || 0) + 1;
    return { set: set, list: Object.keys(set) };
  }

  function prepare(doc) {
    doc._f = {
      title: fieldSet(doc.title),
      tags: fieldSet((doc.tags || '') + ' ' + (doc.topic || '')),
      excerpt: fieldSet(doc.excerpt),
      body: fieldSet(doc.body)
    };
    doc._title = norm(doc.title);
    return doc;
  }

  function parseQuery(q) {
    var raw = norm(q).split(' ').filter(Boolean);
    var groups = [];
    raw.forEach(function (w, idx) {
      if (STOP[w] && raw.length > 1) return;
      var alts = [[stem(w)]];
      (SYNONYMS[w] || []).forEach(function (s) { alts.push(tokens(s)); });
      groups.push({ word: w, alts: alts, last: idx === raw.length - 1 });
    });
    if (!groups.length && raw.length) {
      groups = raw.map(function (w, idx) { return { word: w, alts: [[stem(w)]], last: idx === raw.length - 1 }; });
    }
    return groups;
  }

  /* Best match quality of one term in one field: 1 exact, .75 prefix, .5 typo, 0 none. */
  function matchTerm(term, field, allowPrefix) {
    if (field.set[term]) return 1;
    var best = 0, list = field.list, i, t;
    var maxEdits = term.length >= 8 ? 2 : term.length >= 4 ? 1 : 0;
    for (i = 0; i < list.length; i++) {
      t = list[i];
      if (allowPrefix && term.length >= 2 && t.length > term.length && t.lastIndexOf(term, 0) === 0) {
        if (best < 0.75) best = 0.75;
      } else if (term.length >= 4 && t.length >= 4 && term.lastIndexOf(t, 0) === 0 && term.length - t.length <= 2) {
        if (best < 0.7) best = 0.7;
      } else if (maxEdits && best < 0.5 && t.charCodeAt(0) === term.charCodeAt(0) && near(term, t, maxEdits)) {
        best = 0.5;
      }
    }
    return best;
  }

  /* Score one term across all fields; returns the best weighted score. */
  function scoreTerm(doc, term) {
    var best = 0;
    for (var f in WEIGHT) {
      var q = matchTerm(term, doc._f[f], true);
      if (!q) continue;
      var s = q * WEIGHT[f];
      if (f === 'body' && q === 1) s += Math.min(doc._f.body.set[term], 5) * 0.2;
      if (s > best) best = s;
    }
    return best;
  }

  function scoreDoc(doc, groups, phrase, relaxed) {
    var total = 0, matched = 0, hits = [];
    for (var g = 0; g < groups.length; g++) {
      var grp = groups[g], bestForGroup = 0;
      for (var a = 0; a < grp.alts.length; a++) {
        var alt = grp.alts[a], sum = 0, all = true;
        for (var t = 0; t < alt.length; t++) {
          var s = scoreTerm(doc, alt[t]);
          if (!s) { all = false; break; }
          sum += s;
        }
        if (!all) continue;
        var altScore = (sum / alt.length) * (a === 0 ? 1 : 0.6);
        if (altScore > bestForGroup) bestForGroup = altScore;
        for (t = 0; t < alt.length; t++) hits.push(alt[t]);
      }
      if (bestForGroup > 0) { matched++; total += bestForGroup * (grp.w || 1); }
    }
    if (!matched) return null;
    var coverage = matched / groups.length;
    var need = groups.length <= 2 ? 1 : 0.6;
    if (!relaxed && coverage < need) return null;
    total *= coverage * coverage;
    if (phrase.length > 3 && doc._title.indexOf(phrase) >= 0) total += 20;
    return { score: total, hits: hits };
  }

  function run(docs, groups, phrase, opts, relaxed) {
    var out = [];
    for (var i = 0; i < docs.length; i++) {
      var d = docs[i];
      if (opts.topic && d.topicId !== opts.topic) continue;
      var r = scoreDoc(d, groups, phrase, relaxed);
      if (r) out.push({ doc: d, score: r.score, hits: r.hits, partial: !!relaxed });
    }
    return out;
  }

  /* Strict pass first; if nothing matches every word, fall back to partial matches. */
  function search(docs, query, opts) {
    opts = opts || {};
    var groups = parseQuery(query);
    if (!groups.length) return [];
    var phrase = norm(query);
    /* Rare words count for more than words that appear in nearly every guide. */
    var n = docs.length, logN = Math.log(1 + n);
    groups.forEach(function (grp) {
      var term = grp.alts[0][0], df = 0;
      for (var i = 0; i < n; i++) {
        var f = docs[i]._f;
        if (f.title.set[term] || f.tags.set[term] || f.excerpt.set[term] || f.body.set[term]) df++;
      }
      grp.w = 0.35 + 0.65 * (Math.log(1 + n / (1 + df)) / logN);
    });
    var out = run(docs, groups, phrase, opts, false);
    if (!out.length && groups.length > 1) out = run(docs, groups, phrase, opts, true);
    out.sort(function (a, b) { return b.score - a.score || a.doc.title.localeCompare(b.doc.title); });
    return out.slice(0, opts.limit || 12);
  }

  return { prepare: prepare, search: search, norm: norm, stem: stem, parseQuery: parseQuery, synonyms: SYNONYMS };
})();

if (typeof module !== 'undefined') module.exports = LearnSearch;

if (typeof document !== 'undefined') (function () {
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function highlight(text, hits) {
    if (!hits.length) return esc(text);
    return text.split(/(\s+)/).map(function (part) {
      var stemmed = LearnSearch.stem(LearnSearch.norm(part).split(' ')[0] || '');
      if (!stemmed) return esc(part);
      for (var i = 0; i < hits.length; i++) {
        if (stemmed === hits[i] || (hits[i].length >= 2 && stemmed.lastIndexOf(hits[i], 0) === 0)) {
          return '<mark>' + esc(part) + '</mark>';
        }
      }
      return esc(part);
    }).join('');
  }

  function snippet(doc, hits) {
    if (!doc.body || !hits.length) return doc.excerpt;
    var words = doc.body.split(/\s+/);
    for (var i = 0; i < words.length; i++) {
      var w = LearnSearch.stem(LearnSearch.norm(words[i]).split(' ')[0] || '');
      for (var h = 0; h < hits.length; h++) {
        if (w && w === hits[h]) {
          var start = Math.max(0, i - 10);
          return (start ? '… ' : '') + words.slice(start, start + 32).join(' ') + ' …';
        }
      }
    }
    return doc.excerpt;
  }

  function init(root) {
    var input = root.querySelector('[data-learn-input]');
    var form = root.querySelector('[data-learn-form]');
    var results = root.querySelector('[data-learn-results]');
    var status = root.querySelector('[data-learn-status]');
    var clear = root.querySelector('[data-learn-clear]');
    var chips = [].slice.call(root.querySelectorAll('[data-learn-chip]'));
    var topicsWrap = root.querySelector('[data-learn-topics]');
    if (!input || !results) return;

    var docs = [].slice.call(root.querySelectorAll('[data-learn-article]')).map(function (el) {
      var link = el.querySelector('a');
      var ex = el.querySelector('[data-learn-excerpt]');
      return LearnSearch.prepare({
        title: link.textContent.trim(),
        url: link.getAttribute('href'),
        excerpt: ex ? ex.textContent.trim() : '',
        tags: el.getAttribute('data-tags') || '',
        topic: el.getAttribute('data-topic-title') || '',
        topicId: el.getAttribute('data-topic') || '',
        body: ''
      });
    });
    var byUrl = {};
    docs.forEach(function (d) { byUrl[d.url] = d; });

    var activeTopic = '', loaded = false, loading = false, trackTimer;

    function loadBodies() {
      if (loaded || loading) return;
      loading = true;
      var handles = (root.getAttribute('data-blogs') || '').split(',').filter(Boolean);
      var base = root.getAttribute('data-blog-base') || '/blogs/';
      Promise.all(handles.map(function (h) {
        return fetch(base + h + '?view=learn-index', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) {
            var data;
            try { data = JSON.parse(t); } catch (e) { return; }
            (data.articles || []).forEach(function (a) {
              var d = byUrl[a.u];
              if (d && !d.body) { d.body = a.b || ''; LearnSearch.prepare(d); }
            });
          })
          .catch(function () {});
      })).then(function () {
        loaded = true; loading = false;
        if (input.value.trim()) render();
      });
    }

    function setUrl(q) {
      if (!window.history || !history.replaceState) return;
      try {
        var u = new URL(window.location.href);
        if (q) u.searchParams.set('q', q); else u.searchParams.delete('q');
        history.replaceState(null, '', u.toString());
      } catch (e) {}
    }

    function render() {
      var q = input.value.trim();
      if (clear) clear.hidden = !q;
      root.classList.toggle('learn-hub--searching', !!q);
      if (!q) {
        results.hidden = true; results.innerHTML = '';
        if (status) status.textContent = '';
        if (topicsWrap) topicsWrap.hidden = false;
        setUrl('');
        return;
      }
      var found = LearnSearch.search(docs, q, { topic: activeTopic });
      var html = '';
      if (!found.length) {
        html = '<p class="learn-hub__empty">No guides match <strong>' + esc(q) + '</strong>' +
          (activeTopic ? ' in this topic' : '') + '. Try different words' +
          (root.getAttribute('data-support-url') ? ', or <a href="' + esc(root.getAttribute('data-support-url')) + '">' +
            esc(root.getAttribute('data-support-label') || 'contact support') + '</a>' : '') + '.</p>';
      } else {
        html = '<ol class="learn-hub__result-list">' + found.map(function (r) {
          var d = r.doc, sn = snippet(d, r.hits);
          return '<li class="learn-hub__result"><a class="learn-hub__result-link" href="' + esc(d.url) + '">' +
            '<span class="learn-hub__result-title">' + highlight(d.title, r.hits) + '</span>' +
            (d.topic ? '<span class="learn-hub__result-topic">' + esc(d.topic) + '</span>' : '') +
            (sn ? '<span class="learn-hub__result-text">' + highlight(sn, r.hits) + '</span>' : '') +
            '</a></li>';
        }).join('') + '</ol>';
      }
      results.innerHTML = html;
      results.hidden = false;
      if (topicsWrap) topicsWrap.hidden = true;
      if (status) status.textContent = found.length ? found.length + (found.length === 1 ? ' guide found' : ' guides found') : 'No guides found';
      setUrl(q);

      clearTimeout(trackTimer);
      trackTimer = setTimeout(function () {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'search', { search_term: q, learn_hub_results: found.length });
        }
      }, 1500);
    }

    var timer;
    input.addEventListener('input', function () {
      loadBodies();
      clearTimeout(timer);
      timer = setTimeout(render, 80);
    });
    input.addEventListener('focus', loadBodies);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; render(); }
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      render();
      var first = results.querySelector('a');
      if (first) first.focus();
    });
    if (clear) clear.addEventListener('click', function () { input.value = ''; render(); input.focus(); });

    chips.forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        var topic = chip.getAttribute('data-learn-chip');
        if (!input.value.trim()) {
          if (!topic) e.preventDefault();
          return;
        }
        e.preventDefault();
        activeTopic = topic;
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        render();
      });
    });

    [].slice.call(root.querySelectorAll('[data-learn-more]')).forEach(function (btn) {
      var list = btn.parentNode.querySelector('[data-learn-list]');
      if (!list) return;
      list.classList.add('is-collapsed');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = list.classList.toggle('is-collapsed') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });

    try {
      var initial = new URL(window.location.href).searchParams.get('q');
      if (initial) { input.value = initial; loadBodies(); render(); }
    } catch (e) {}
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-learn-hub]')).forEach(function (el) {
      if (el.__learnInit) return;
      el.__learnInit = true;
      init(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
